import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "../lib/site";
import Logo, { BrandText } from "./Logo";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLang } from "../i18n/LanguageContext";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { t } = useLang();
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const nav = [
    { to: "/", label: t("nav.home") },
    { to: "/tjenester", label: t("nav.services") },
    { to: "/prosjekter", label: t("nav.projects") },
    { to: "/om-oss", label: t("nav.about") },
    { to: "/be-om-pristilbud", label: t("nav.quote") },
    { to: "/kontakt", label: t("nav.contact") },
  ];

  return (
    <header className="sticky top-0 z-30 bg-[#F7F5F0]/95 backdrop-blur border-b border-[#E2DDD5]">
      <div className="container-page flex items-center justify-between h-[72px] gap-3">
        <Link to="/" className="flex items-center gap-2.5" data-testid="header-logo">
          <Logo size={40} />
          <BrandText compact />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-7">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) => `text-[14px] xl:text-[15px] font-semibold link-underline ${isActive ? "text-[#1B3626]" : "text-[#1C1F22] hover:text-[#1B3626]"}`}
              data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
            >{n.label}</NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2 xl:gap-3">
          <LanguageSwitcher />
          <a href={`tel:${COMPANY.phoneClean}`} className="btn-primary !py-2.5 !px-3.5 text-sm" data-testid="header-call-btn">
            <Phone size={15} /> {COMPANY.phone}
          </a>
        </div>

        <div className="lg:hidden flex items-center gap-2">
          <LanguageSwitcher />
          <button className="p-2 rounded-md border border-[#E2DDD5] bg-white" onClick={() => setOpen((v) => !v)} aria-label={open ? "Lukk meny" : "Åpne meny"} data-testid="header-hamburger">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E2DDD5] bg-[#F7F5F0]">
          <nav className="container-page py-3 flex flex-col">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) => `py-3 border-b border-[#E7E2D7] font-semibold ${isActive ? "text-[#1B3626]" : "text-[#1C1F22]"}`}
                data-testid={`mnav-${n.to.replace(/\//g, "") || "home"}`}
              >{n.label}</NavLink>
            ))}
            <a href={`tel:${COMPANY.phoneClean}`} className="btn-primary mt-4" data-testid="mnav-call">
              <Phone size={16} /> {t("hero.callBtn")} {COMPANY.phone}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
